import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../../context/ThemeContext";
import UserContext from "../../../../../../context/UserContext";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../../lang/LangGlb';
import { InputText } from "primereact/inputtext";

const GET_POST = gql`
  query MyQuery12($firmSubCode: String!,$seaId: Int!, $perId: Int, $firmMainCode: String!) {
    tbl_dyn_price_grp_def(
      where: {
        firm_main_code: { _eq: $firmMainCode},
        firm_sub_code: { _eq: $firmSubCode },
        id_seq: { _eq: $perId },
        grp_main_id: { _eq: $seaId },

      }
    ) {
        firm_main_code
        firm_sub_code
        id_seq
        grp_main_id
        dyn_grp_code       
        dyn_grp_percent
        dyn_grp_percent
        dyn_grp_sup_red_type
     
    }
  }
`;




const UPDATE_FIRM = gql`
mutation UpdateRoomClass(
  $firmMainCode: String!
  $firmSubCode: String!
  $perId: Int!
  $seaId: Int!
  $startDate: date
  $endDate: date
  $perCode: Int,
  $releaseDay: String,
  $minStayDay: Int,
  $perPricePercent: Int
  

) {
  update_tbl_dyn_price_grp_def(
    where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        id_seq: { _eq: $perId },
        grp_main_id: { _eq: $seaId },
        

    },
    _set: {
    
      dyn_grp_code: $perCode,
      dyn_grp_sup_red_type: $releaseDay,
      
      dyn_grp_percent: $perPricePercent


       }
  ) {
    affected_rows
  }
}
`;

const INSERT_PER = gql`
  mutation InsertPeriod(
    $seaId: Int
    $firmMainCode: String
    $firmSubCode: String
    $perId: Int
    $startDate: date
    $endDate: date
    $perCode: Int,
    $releaseDay: String,
    $minStayDay: Int,
    $perPricePercent: Int
   
   
    
  ) {
    insert_tbl_dyn_price_grp_def(
      objects: {
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        id_seq: $perId,
        grp_main_id: $seaId,
       
        dyn_grp_code: $perCode,
        dyn_grp_sup_red_type: $releaseDay,
      
       dyn_grp_percent: $perPricePercent
        

        
      }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const INSERT_RCLASS = gql`
  mutation InsertRoomClass(
    
    $rClassName: String!
    $rClassCode: String!
    $ownFirmCode: String!
    $ownFirmSubCode: String!
    $active: Boolean!
    
    
  ) {
    insert_tbl_htl_room_class(
      objects: {
       
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        r_class_code: $rClassCode,
        r_class_name: $rClassName,
        active: $active,
        
        
      }
    ) {
      affected_rows
    }
  }
`;









const HtlDynPriceGrpDtl = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  const { varCode2, setVarCode2 } = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmSubCode: firmSubCode, firmMainCode: firmMainCode, seaId: varCode , perId: varCode2},
  });
  const [UpdateRoomClass] = useMutation(UPDATE_FIRM);
  const [InsertPeriod] = useMutation(INSERT_PER);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 

  const firmData = data && data.tbl_dyn_price_grp_def ? data.tbl_dyn_price_grp_def[0] : null;

 



 
  const [active, setActive] = useState(firmData ? firmData.active : true);
  const [perId, setPerId] = useState(firmData ? firmData.id_seq : "");
  const [seaId, setSeaId] = useState(firmData ? firmData.sea_id_seq : "");
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());
  const [perCode, setPerCode] = useState(firmData ? firmData.period : "");
  const [releaseDay, setReleaseDay] = useState(firmData ? firmData.release : "");
  const [minStayDay, setMinStayDay] = useState(firmData ? firmData.min_stay : "");
  const [perPricePercent, setPerPricePercent] = useState(firmData ? firmData.per_price_percent : "");


  
  
  
  console.log("Firm Data:", firmData);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  


  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  
  const updaterec = messages[currentLocale].updaterec;  
  const sea_new_per_btn = messages[currentLocale].sea_new_per_btn;  
  const dynamic_price_id_title = messages[currentLocale].dynamic_price_id_title;
  const dynamic_price_group_code_title = messages[currentLocale].dynamic_price_group_code_title;
  const dynamic_price_group_percent_title = messages[currentLocale].dynamic_price_group_percent_title;
  const dynamic_persent_conde_title = messages[currentLocale].dynamic_persent_conde_title;
  

  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (perId !== '') {
      // newId güncellendiğinde  işlevini çağırarak firmCode'u güncelliyor
      
      handleinsert();  
    
    }
  }, [perId, setPerId]);
  
  useEffect(() => {
    if (firmData) {
      setPerId(firmData.id_seq);
      setSeaId(firmData.grp_main_id);
      setStartDate(new Date(firmData.start_date));
      setEndDate(new Date(firmData.end_date));
      setPerCode(firmData.dyn_grp_code);
      setReleaseDay(firmData.dyn_grp_sup_red_type);
      setMinStayDay(firmData.min_stay);
      setPerPricePercent(firmData.dyn_grp_percent);
      
      
    }
  }, [firmData]);

  

  const handleUpdate = () => {
    UpdateRoomClass({
      variables: {
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        perId: perId,
        seaId: seaId,
      
        perCode:perCode,
        releaseDay:releaseDay,
       
        perPricePercent:perPricePercent
      

        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };

  const handleinsert = () => {
    InsertPeriod({
      variables: {

        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        perId: perId,
        seaId: seaId,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        perCode:perCode,
        releaseDay:releaseDay,
        minStayDay:minStayDay,
        perPricePercent:perPricePercent
       
    
           
      },
    })
      .then(() => {
        window.alert("Period insert successfully!");
        setStartDate(endDate);
      })
      .catch((error) => {
        console.error("Error insert Period:", error);
      });
  };

  const handleUpdateIdSeq = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setPerId(updatedIdSeq.toString());  
      setVarCode2(updatedIdSeq.toString());  
      console.log(perId);
      setSeaId(varCode);
     
       
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;

return (
  <div className="container mt-0 p-2 mx-auto  dark:text-gray-100">
    

    
    <div className="flex">
   <div className="mr-2 w-1/3" >
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {dynamic_price_id_title}
    </label>
    <InputNumber
      inputId="integeronly"
      useGrouping={false} 
      
      value={seaId}
      onValueChange={(e) => setSeaId(e.value)}
      className="w-full h-11  border-gray-300 rounded-md "
      readOnly
   />
  </div>

  <div className="mr-2 w-1/3" >
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {"id'"}
    </label>
    <InputNumber 
      inputId="integeronly"
      useGrouping={false} 
      value={perId}
      onValueChange={(e) => setPerId(e.value)}
      className="w-full h-11  border-gray-300 rounded-md "
      
   />
  </div>
  </div> 
    
    
    <div className="flex mt-2">

    <div className=" w-1/3" >
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {dynamic_price_group_code_title}
    </label>
    <InputNumber 
      inputId="integeronly"
      useGrouping={false} 
      value={perCode}
      onValueChange={(e) => setPerCode(e.value)}
      className="w-full h-11  border-gray-300 rounded-md "
      r
   />
  </div>
  
  

  <div className="w-1/3 ml-3 h-10 gap-3">
  <label htmlFor="firmType" className="block font-medium text-gray-700">
      {dynamic_persent_conde_title}
    </label>
    <InputText    
      id="periodCode"   
      value={releaseDay}
      onChange={(e) => setReleaseDay(e.target.value)}

      
      className="w-full h-11  border-gray-300 rounded-md "
      
   />
   
  </div>

   <div className="w-1/3 ml-3 h-10 gap-3">
   <label htmlFor="firmType" className="block font-medium text-gray-700">
      {dynamic_price_group_percent_title}
    </label>
    <InputNumber     
      inputId="integeronly"  
      useGrouping={false}     
      value={perPricePercent}
      onValueChange={(e) => setPerPricePercent(e.value)}
      className="w-full h-11  border-gray-300 rounded-md "
      
   />
  
  </div> 
  
  </div>

    <div className="mt-4 flex justify-end">
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdate}
      >
        {updaterec}
      </button>
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdateIdSeq}
      >
        {sea_new_per_btn}
      </button>
    </div>
  </div>
);
};

export default HtlDynPriceGrpDtl;
